import leo from 'leo-profanity';

// Add extra banned words (misspellings, slurs, etc.)
leo.add(['pro$titution', 'fuk', 'b1tch', 'r@pe', 'nazi', 'f*ck', 'sh*t', 'b*tch']);

export function isSafeForAds(groupName, words, mod) {
  const allText = [
    groupName,
    ...words.flatMap(w => [w.from_text, w.to_text])
  ].join(' ').toLowerCase();

  return !leo.check(allText);
}

// NEW: Check individual text input
export function isTextSafe(text) {
  if (!text || typeof text !== 'string') return true;
  return !leo.check(text);
}

// NEW: Check topic/dialect specifically
export function isTopicSafe(topic) {
  if (!topic || typeof topic !== 'string') return true;
  return !leo.check(topic);
}